import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { iOutChangingStat } from 'src/app/core/interfaces/common';
import { CommonService } from 'src/app/core/services/common.service';
import { DocumentService } from 'src/app/core/services/document.service';
import FileUtils, { ContentType } from 'src/app/core/services/file-utils';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import {CreateContractService} from "../../../core/services/create-contract.service";

@Component({
  selector: 'app-upload-multi-file',
  templateUrl: './upload-multi-file.component.html',
  styleUrls: ['./upload-multi-file.component.scss']
})
export class UploadMultiFileComponent implements OnInit, iOutChangingStat, OnChanges {
  // refresh input file
  @ViewChild('inputUpload', { read: '', static: false }) inputUploadFile: ElementRef;

  // share data from arr attchment when call method get view detail
  @Input() arrAttachments: any[];

  // share data from arr attchment of customer in screen add-document
  @Input() arrAttachmenstOfCustomer: any[];

  // check for view detail
  @Input() isViewDetail: boolean;

  // check for view detail
  @Input() isCustomer: boolean;

  // check for view detail
  @Input() isAttachFileForDocument: boolean;

  @Input() maxSize: number = 10485760;
  @Input() checkMan: any;

  @Input() messageError: string = ''

  // Let parent component this changing status
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();

  public hasOverride: boolean = false;

  // array file
  listFile: any[] = [];

  maxSizeMessage: string = ''

  // check max size
  maxSizeInput = false;

  // check form changing
  isFormChanging = false;

  /**
   * Check format type file
   */
  errorFormatTypeFile = false;

  acceptContentType: ContentType[] = [ContentType.PDF, ContentType.BMP, ContentType.JPEG, ContentType.PNG];

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private documentService: DocumentService,
    private message: Message,
    private createContractService: CreateContractService,
    private toastr: ToastrService
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.maxSizeMessage = this.messageError
      ? this.messageError
      : this.message.getMessage('validation.file');
    if(this.arrAttachments && this.arrAttachments.length){
      let totalSize = 0
      this.arrAttachments.forEach(attach => {
        if (attach.fileSize !== undefined) {
          totalSize = totalSize + attach.fileSize;
        } else {
          totalSize = totalSize + attach.size;
        }
      });

      if(totalSize > this.maxSize){
        this.maxSizeInput = true;
      }else
        this.maxSizeInput = false;
    }
  }

  ngOnInit() {
    if (this.arrAttachments === undefined) {
      this.arrAttachments = [];
    }
  }
  getFileNew(){
    this.createContractService.dataDocumentParentNewUploadContractAttachments.next(this.arrAttachments);
  }

  // get file from selected file
  async getFiles(e) {
    this.hasOverride = false;
    const attachLengthBeforeUpload: number = this.arrAttachments.length;
    this.maxSizeInput = false;
    this.errorFormatTypeFile = false;

    // simple check mime-type based on file extension
    if (!this.checkFormatTypeFile(e.target.files)) {
      // Check file size of list file when selected upload
      if (!this.totalSize(e.target.files)) {
        await this.checkContentTypeThenAddToList(e.target.files);
      }
    }

    this.reset();
    const hasSucceedFile = this.arrAttachments.length > attachLengthBeforeUpload;
    if (hasSucceedFile) {
      this.setFormChanging(true);
    }
  }

  private async checkContentTypeThenAddToList(files: File[]): Promise<boolean> {
    let r = true;
    await this.checkContentTypeFile(files).then(rs => {
      r = rs;
      if (rs) {
        this.addToList(files);
      }
    });
    return new Promise((resolve, reject) => resolve(r));
  }

  private async checkContentTypeFile(files: File[]): Promise<boolean> {
    let r = true;
    for (const file of files) {
      const ct: ContentType = await FileUtils.getContentType(file);
      if (!this.acceptContentType.includes(ct)) {
        this.errorFormatTypeFile = true;
        r = false;
        break;
      }
    }
    return new Promise((resolve, reject) => resolve(r));
  }

  private addToList(files: File[]) {
    const duplicateFile: File[] = [];
    for (const file of files) {
      if (this.arrAttachments.length > 0) {
        let check = false;
        for (let j = 0; j < this.arrAttachments.length; j++) {
          if (this.arrAttachments[j].fileName !== undefined) {
            if (file.name === this.arrAttachments[j].fileName) {
              check = true;
              duplicateFile.push(file);
            }
          } else {
            if (file.name === this.arrAttachments[j].name) {
              check = true;
              duplicateFile.push(file);
            }
          }
        }
        if (!check) {
          this.arrAttachments.push(file);
        }
      } else {
        this.arrAttachments.push(file);
      }
    }
    if (duplicateFile !== undefined && duplicateFile.length > 0) {
      this.showDialog(duplicateFile)
        .afterClosed()
        .subscribe(rs => {
          if (rs) {
            this.overriedDuplicated(this.arrAttachments, duplicateFile);
            this.hasOverride = true;
            this.setFormChanging(true);
          }
        });
    }
  }

  /**
   * Check type file when upload ( Accept file img and pdf )
   */
  checkFormatTypeFile(files): boolean {
    for (let i = 0; i < files.length; i++) {
      if (files[i].type !== 'application/pdf' && files[i].type.slice(0, 6) !== 'image/') {
        this.errorFormatTypeFile = true;
      }
    }

    if (this.errorFormatTypeFile) {
      return true;
    } else {
      return false;
    }
  }

  // overried file duplicated
  private overriedDuplicated(arrAttach, duplicateFile) {
    duplicateFile = duplicateFile.filter((v, i, a) => a.indexOf(v) === i);
    // console.log(arrAttach);
    // console.log(duplicateFile);
    let dupList = [];
    let pushList = [];
    for (let i = 0; i < arrAttach.length; i++) {
      for (let j = 0; j < duplicateFile.length; j++) {
        if ((arrAttach[i].fileName !== undefined && duplicateFile[j].name === arrAttach[i].fileName) || (arrAttach[i].fileName === undefined && duplicateFile[j].name === arrAttach[i].name)) {
          dupList.push(arrAttach[i]);
          pushList.push(duplicateFile[j]);
        }
      }
    }

    // console.log(dupList);
    // console.log(pushList);
    dupList.forEach(x => { arrAttach.splice(arrAttach.indexOf(x), 1); });
    pushList.forEach(x => { arrAttach.push(x) });
    this.reset();
  }

  // check total max size for all file attachment
  private totalSize(files): boolean {
    let totalSize = 0;

    // List arrAttachments include file old and file new when selected upload
    this.arrAttachments.forEach(attach => {
      if (attach.fileSize !== undefined) {
        totalSize = totalSize + attach.fileSize;
      } else {
        totalSize = totalSize + attach.size;
      }
    });

    for (let i = 0; i < files.length; i++) {
      totalSize = totalSize + files[i].size;
    }

    if (totalSize > this.maxSize) {
      this.maxSizeInput = true;
      return true;
    } else {
      return false;
    }
  }

  // upload multi file
  uploadFile(successCallback: () => void, noUpload: () => void) {
    const fileUpload = this.arrAttachments.filter(
      arrAttachments => arrAttachments.name != undefined);

    if (fileUpload.length > 0) {
      // Upload file for case attactment for document
      // if (this.isAttachFileForDocument) {
      //   // Arr file upload for document
      //   const fileUploadForDocument = this.arrAttachments.filter(
      //     arrAttachments => arrAttachments.id == null);
      //   this.documentService.uploadMultiFileAttachForDocument(fileUploadForDocument)
      //     .subscribe(rs => {
      //       this.uploadFileSuccess(rs, successCallback);
      //     });
      // } else {
      if (this.isCustomer && this.isCustomer != undefined) {
        this.commonService.uploadMultiFileCustomer(fileUpload)
          .subscribe(rs => {
            this.uploadFileSuccess(rs, successCallback);
          });
      } else {
        this.commonService.uploadMultiFile(fileUpload)
          .subscribe(rs => {
            this.uploadFileSuccess(rs, successCallback);
          });
      }
      // }
    } else {
      noUpload();
    }
  }

  // after upload success
  private uploadFileSuccess(rs, successCallback: (data) => void) {
    for (let i = 0; i < rs.data.length; i++) {
      this.arrAttachments.push(rs.data[i]);
    }

    this.arrAttachments = this.arrAttachments.filter(
      arrAttachments => arrAttachments.fileName !== undefined);
    successCallback(this.arrAttachments);
  }

  // remove file from arr listFile for arr file add
  deleteFile(item) {
    this.maxSizeInput = false;
    let totalSize = 0;

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.message.getMessage('popup.confirm_delete_file')
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        const index = this.arrAttachments.indexOf(item);
        if (index > -1) {
          this.arrAttachments.splice(index, 1);
        }

        this.toastr.success(this.message.getMessage('messages.delete_success'));

        const arrAttachments = this.arrAttachments.filter(
          arrAttachment => arrAttachment.name !== undefined);

        arrAttachments.forEach(element => {
          totalSize += element.size;
        });
        this.totalSize(totalSize);
        this.setFormChanging(true);
        this.reset();
      }
    });
  }

  // show dialog file duplicated
  private showDialog(duplicateFile) {
    let code = '<ul>';

    for (let i = 0; i < duplicateFile.length; i++) {
      if (duplicateFile[i].name !== undefined) {
        code += '<li>' + duplicateFile[i].name + '</li>';
      } else {
        code += '<li>' + duplicateFile[i].fileName + '</li>';
      }
    }

    code += '</ul>';

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '430px',
      data: this.message.getMessage('popup.confirm_override_file') + code,
    });

    return dialogRef;
  }


  // refresh input
  private reset() {
    this.inputUploadFile.nativeElement.value = '';
  }

  /**
   * Download file.
   * @param path the encrypt path.
   * @param fileName file name of file.
   */
  donwloadUrl(id: string, fileName: string) {
    if (this.isCustomer && this.isCustomer !== undefined) {
      return this.commonService.downloadFileCustomer(id).subscribe(
        rs => {
          this.downLoadFile(rs, 'application/octet-stream', fileName);
        }
      );
    } else {
      return this.commonService.downloadFileEnterprises(id).subscribe(
        rs => {
          this.downLoadFile(rs, 'application/octet-stream', fileName);
        }
      );
    }
  }

  /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   * @param fileName - file name of file
   */
  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type });
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  /**
   * Update changing status and share with other component.
   */
  setFormChanging(changingStatus: boolean) {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

}
